import {QuestionMarkCircleIcon} from '@heroicons/react/24/outline';
import {useState} from 'react';
import {SimpleOverlay, cn} from '..';

export type QuestionModalProps = {
  content: React.ReactNode;
  className?: string;
  localeText: {
    title: string;
    okay: string;
  };
};

export const QuestionModal = ({content, localeText}: QuestionModalProps) => {
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <>
      <button type="button" onClick={() => setModalOpen(true)}>
        <QuestionMarkCircleIcon className={cn('w-5 h-5 text-gray-400')} />
      </button>
      <SimpleOverlay open={isModalOpen} setOpen={setModalOpen} localeText={localeText}>
        <div className="px-4 py-3 text-sm text-gray-900 max-h-[600px] overflow-auto">{content}</div>
      </SimpleOverlay>
    </>
  );
};
